import { render, staticRenderFns } from "./ExpressAdmin.vue?vue&type=template&id=f5948540&scoped=true"
import script from "./ExpressAdmin.vue?vue&type=script&lang=js"
export * from "./ExpressAdmin.vue?vue&type=script&lang=js"
import style0 from "./ExpressAdmin.vue?vue&type=style&index=0&id=f5948540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5948540",
  null
  
)

export default component.exports